define('SageDotCom/DataLayer/Events/top-nav-interaction',[
    "SageDotCom/DataLayer/Events/eventBase"
], function (EventBase) {

    function TopNavInteractionEvent(el, label) {
        EventBase.call(this);

        var id = this.cleanseString(this.getId(el));

        this.props = {
            "event_name": "top_nav_int",
            "event_non-int ": "0",
            "event_category": "component",
            "event_action": "top_nav_int",
            "event_label": this.cleanseString(label),
            "event_name_level_1": id,
            "event_name_level_2": "left",
            "event_name_level_3": "",
            "event_name_level_4": ""
        };
    }

    TopNavInteractionEvent.prototype = Object.create(EventBase.prototype);

    return TopNavInteractionEvent;
});
